var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Gray",
    transform: "translate(-10010 760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Gray-2",
    "data-name": "Dashboard_Gray",
    transform: "translate(10010 -760)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140092",
    "data-name": "Rectangle 140092",
    width: 12,
    height: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "col-left-svgrepo-com",
    transform: "translate(-1.309 -1.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M3,5.862C3,3.505,3.505,3,5.862,3h2.9c2.357,0,2.862.505,2.862,2.862v2.9c0,2.357-.505,2.862-2.862,2.862h-2.9C3.505,11.62,3,11.115,3,8.758Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#71839b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M12,3v8.62",
    transform: "translate(-4.69 0)",
    fill: "none",
    stroke: "#71839b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M16.31,12H12",
    transform: "translate(-4.69 -4.69)",
    fill: "none",
    stroke: "#71839b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhiteIcon);
export default __webpack_public_path__ + "static/media/dashboard-white-icon.3bc86d63433c53ec96e0389ce0f0b62f.svg";
export { ForwardRef as ReactComponent };